export enum FetchStatus {
  ERROR, SUCCESS, NOT_FOUND, PENDING
}
